// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_3uJZnQjvCCnkG2ej8OQ_Xa","externalId":"_1ozmCmP-2Zu89EcTWJPCzF"};